// import {Login} from "./Login"
// import App from "../../App"
import {BrowserRouter, Route, Routes} from "react-router-dom";
//import {NewSurveyor} from "../../components/mantenedores/surveyors/NewSurveyor";
import {
    IngresarSurveyorPorPagina
} from "../../components/mantenedores/surveyors/pagina_surveyor/IngresarSurveyorPorPagina";
// import {TresModulos} from "./TresModulos";
export const Ruta = () => {

    let ingresaNuevoSurveyor = <IngresarSurveyorPorPagina/>
    return (
        <BrowserRouter>
            <Routes>
                <Route exact path='*' element={ingresaNuevoSurveyor}/>
            </Routes>
        </BrowserRouter>
    )
}
